<template>
  <div class="my-10">
    <div class="flex justify-center px-4 items-center">
      <h1 class="text-3xl font-bold text-center">{{ __("Edit client") }}</h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10">
      <div class="max-w-5xl w-full mx-auto my-10 flex flex-col items-center">
        <form class="mt-2" @submit.prevent="submitClientForm">
          <div class="flex flex-wrap -mx-4">
            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.first_name" :data-error="error('first_name', `client.${client.id}`)" class="w-full pb-8" :label="__('First name')"/>
            </div>
            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.last_name" :data-error="error('last_name', `client.${client.id}`)" class="w-full pb-8" :label="__('Last name')"/>
            </div>
            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.email" :data-error="error('email', `client.${client.id}`)" class="w-full pb-8" :label="__('Email')"/>
            </div>
            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.phone" :data-error="error('phone', `client.${client.id}`)" class="w-full pb-8" :label="__('Phone')"/>
            </div>
            <div class="px-4 w-full">
              <text-input v-model="form.address" :data-error="error('address', `client.${client.id}`)" class="w-full pb-8" :label="__('Address')"/>
            </div>
            <div class="px-4 w-full flex justify-center items-center">
              <loading-button :loading="sendingClientForm" class="btn-primary" type="submit">
                {{ __("Save client") }}
              </loading-button>
            </div>
          </div>
        </form>
      </div>

      <div class="my-20 overflow-scroll">
        <h1 class="text-center text-2xl" ref="cars">{{ __("Cars") }}</h1>

        <table class="mt-10 w-full">
          <tr class="bg-gray-700 text-gray-100">
            <th class="p-4 w-10">{{ __("Id") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Registration number") }}</th>
            <th class="p-4 text-left min-w-40" v-if="false">{{ __("Vin") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Brand") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Model") }}</th>
            <th class="p-4 text-left min-w-40" v-if="false">{{ __("Year") }}</th>
            <th class="p-4 text-left min-w-40" v-if="false">{{ __("Engine") }}</th>
            <th class="p-4 text-right w-32">{{ __("Actions") }}</th>
          </tr>

          <tr v-for="(car, index) in cars" v-if="cars.length"
              :class="{'bg-gray-300': index%2 === 0}">
            <td class="p-4 text-center">{{ car.id }}</td>
            <td class="p-4">{{ car.registration_number }}</td>
            <td class="p-4" v-if="false">{{ car.vin }}</td>
            <td class="p-4">{{ car.car_make.name }}</td>
            <td class="p-4">{{ car.model }}</td>
            <td class="p-4" v-if="false">{{ car.year }}</td>
            <td class="p-4" v-if="false">{{ car.engine }}</td>
            <td class="px-4 text-center">
              <div class="flex items-center w-full justify-end">
                <button type="button" @click="toggleEditCar(car)"
                        :class="{'bg-coral-400 text-white': car.id === carForm.id}"
                        class="list-edit-button mr-2">
                  <icon name="edit" class="w-4 h-4 fill-current"></icon>
                </button>
                <button @click="destroyCar(car)" class="list-delete-button">
                  <icon name="delete" class="w-4 h-4 fill-current"></icon>
                </button>
              </div>
            </td>
          </tr>

          <tr class="bg-gray-800">
            <td class="p-2 text-center"></td>
            <td class="p-2">
              <text-input v-model="carForm.registration_number" :data-error="error('registration_number', getCarFormErrorBag())" class="car-form-input w-full" :placeholder="__('Registration number')"/>
            </td>
            <td class="p-2" v-if="false">
              <text-input v-model="carForm.vin" :data-error="error('vin', getCarFormErrorBag())" class="car-form-input w-full" :placeholder="__('Vin')"/>
            </td>
            <td class="p-2">
              <select-input v-model="carForm.car_make_id" :data-errro="error('car_make_id', getCarFormErrorBag())" class="car-form-input w-full" :placeholder="__('Brand')">
                <option value="">{{ __("Brand") }}</option>
                <option v-for="carMake in carMakes" :key="carMake.id" :value="carMake.id">
                  {{ carMake.name }}
                </option>
              </select-input>
              <div v-if="error('car_make_id', getCarFormErrorBag())" class="text-red-500 text-sm mt-2">{{ error('car_make_id', getCarFormErrorBag()) }}</div>
            </td>
            <td class="p-2">
              <text-input v-model="carForm.model" :data-error="error('model', getCarFormErrorBag())" class="car-form-input w-full" :placeholder="__('Model')"/>
            </td>
            <td class="p-2" v-if="false">
              <select-input v-model="carForm.year" :data-error="error('year', getCarFormErrorBag())" class="car-form-input w-full" :placeholder="__('Year')">
                <option v-for="year in years" :key="year" :value="year">
                  {{ year }}
                </option>
              </select-input>
            </td>
            <td class="p-2" v-if="false">
              <text-input v-model="carForm.engine" :data-error="error('engine', getCarFormErrorBag())" class="car-form-input w-full" :placeholder="__('Engine')"/>
            </td>
            <td class="px-4">
              <button class="flex text-white items-center justify-center text-lg w-full px-3 py-2 rounded-lg bg-coral-400 hover:bg-coral-300" @click.prevent="submitCarForm()">
                {{ __("Save") }}
              </button>
            </td>
          </tr>
        </table>
        <div v-if="!cars.length" class="px-10 mt-10">
          {{ __("No cars at the moment...") }}
        </div>
      </div>

      <div class="my-20 overflow-scroll">
        <h1 class="text-center text-2xl">{{ __("Consent forms") }}</h1>

        <table class="mt-10 w-full" v-if="consents.length">
          <tr class="bg-gray-700 text-gray-100">
            <th class="p-4 w-10">{{ __("Id") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Name") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Last update") }}</th>
            <th class="p-4 text-right min-w-40">{{ __("Status") }}</th>
            <th class="p-4 text-center min-w-40">{{ __("PDF") }}</th>
            <th class="p-4 w-40">{{ __("Action") }}</th>
          </tr>

          <tr v-for="(consent, index) in consents" :class="{'bg-gray-300': index%2 === 0}">
            <td class="p-4 text-center">{{ consent.id }}</td>
            <td class="p-4">{{ consent.consentForm.name }}</td>
            <td class="p-4">{{ consent.updated_at }}</td>
            <td class="p-4 text-right">
              {{ consent.status_label }}
            </td>
            <td class="p-4 text-center">
              <a v-if="consent.path" :href="'/storage/'+consent.path" target="_blank" class="bg-coral-400 text-sm px-2 py-1 rounded text-white">{{ __("Open PDF") }}</a>
              <span v-else>-</span>
            </td>
            <td class="p-4 flex justify-end items-center">
              <inertia-link :href="route('consents.send', {consent: consent.id})" v-if="consent.status != 'accepted'" method="post" preserve-scroll class="leading-none pl-2 pr-3 py-2 bg-coral-400 text-white rounded flex items-center hover:bg-coral-300 mr-2">
                <icon name="send" class="w-4 h-4 fill-current mr-2 flex-shrink-0"></icon>
                <span>{{ __("Send") }}</span>
              </inertia-link>
              <button @click="destroyConsent(consent)" class="list-delete-button">
                <icon name="delete" class="w-4 h-4 fill-current"></icon>
              </button>
            </td>
          </tr>
        </table>
        <div v-else class="px-10 mt-10">
          {{ __("No consent forms at the moment...") }}
        </div>
      </div>

      <div class="my-20 max-w-xl mx-auto">
        <form class="mt-2" @submit.prevent="submitConsentForm()">
          <div class="flex flex-col sm:flex-row items-end">
            <select-input v-model="consentForm.consent_form_id" :data-error="error('consent_form_id')" class="w-full mb-4 sm:mb-0 sm:mr-2" :label="__('Send consent form')">
              <option v-for="consentForm in consentForms" :key="consentForm.id" :value="consentForm.id">
                {{ consentForm.name }}
              </option>
            </select-input>

            <loading-button :loading="sendingClientForm" class="btn-primary py-2 text-base flex-shrink-0" type="submit">
              {{ __("Trimite") }}
            </loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/TextInput';
import LoadingButton from '@/Shared/LoadingButton';
import SelectInput from '@/Shared/SelectInput';
import Icon from '@/Shared/Icon';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__("Edit client")
    }
  },
  props: {
    client: Object,
    cars: Array,
    consentForms: Array,
    consents: Array,
    carMakes: Array,
  },
  components: {
    SelectInput,
    TextInput,
    LoadingButton,
    Icon
  },
  data() {
    return {
      datePickerLocale: window.datePickerLocale,
      sendingClientForm: false,
      form: {
        ...this.client
      },
      carForm: this.getEmptyCarForm(),
      consentForm: {
        consent_form_id: null,
        client_id: this.client.id
      }
    }
  },
  mounted() {
    if (this.$refs[this.$page.props.request.target]) {
      this.$refs[this.$page.props.request.target].scrollIntoView();
    }

    this.carForm.registration_number = this.$page.props.request.registrationNumber;

    window.Echo.private('consent-signing.' + this.$page.props.auth.user.id)
        .listen('ConsentUpdatedEvent', (data) => {
          if (data.client_id === this.client.id) {
            this.$inertia.reload({preserveScroll: true, preserveState: true});
          }
        });

    this.cars.forEach((car) => {
      if (this.$page.props.errors.hasOwnProperty(`car.${car.id}`)) {
        this.carForm = {
          ...car,
          ...this.$page.props.oldInput
        };
      }
    });

    if (this.$page.props.errors.hasOwnProperty('car')) {
      this.carForm = {
        ...this.$page.props.oldInput
      };
    }
  },
  computed: {
    years() {
      let years = [];
      for (let start = 1990; start <= new Date().getFullYear(); start++) {
        years.push(start);
      }
      return years;
    }
  },
  methods: {
    getCarFormErrorBag() {
      return this.carForm.id ? 'car.' + this.carForm.id : 'car';
    },
    getEmptyCarForm() {
      return {
        id: null,
        registration_number: '',
        year: 2019,
        car_make_id: '',
        engine: '',
        model: '',
        vin: '',
        owner_id: this.client.id
      }
    },
    toggleEditCar(car) {
      if (this.carForm.id === car.id) {
        this.carForm = this.getEmptyCarForm();
      } else {
        this.carForm = {...car};
      }
    },
    submitCarForm() {
      if (this.carForm.id) {
        this.$inertia.put(this.route('cars.update', {car: this.carForm.id}), this.carForm, {
          preserveScroll: true,
          preserveState: false
        });
      } else {
        let formData = {
          ...this.carForm,
          job_id: this.$page.props.request.job || ''
        };
        this.$inertia.post(this.route('cars.store'), formData, {
          preserveScroll: true,
          preserveState: false
        });
      }
    },
    submitConsentForm() {
      if (!this.consentForm.consent_form_id) {
        return;
      }
      this.$inertia.post(this.route('consents.store'), this.consentForm, {
        preserveScroll: true,
      }).then(() => {
        this.sendingClientForm = false;
      });
    },
    submitClientForm() {
      let data = new FormData();
      data.append('first_name', this.form.first_name || '');
      data.append('last_name', this.form.last_name || '');
      data.append('email', this.form.email || '');
      data.append('phone', this.form.phone || '');
      data.append('address', this.form.address || '');
      data.append('_method', 'put');

      this.sendingClientForm = true;
      this.$inertia.post(this.route('clients.update', {client: this.client.id}), data)
          .then(() => {
            this.sendingClientForm = false;
          });
    },
    destroyCar(car) {
      if (confirm(this.__('Are you sure you want to delete car with registration number :registration_number?', {registration_number: car.registration_number}))) {
        this.$inertia.delete(this.route('cars.destroy', {car: car.id}), {
          preserveScroll: true
        });
      }
    },
    destroyConsent(consent) {
      if (confirm(this.__('Are you sure you want to delete consent form :name?', {name: consent.consentForm.name}))) {
        this.$inertia.delete(this.route('consents.destroy', {consent: consent.id}), {
          preserveScroll: true
        });
      }
    }
  }
}
</script>
